/* Soulskart search-dropdown FAQ answers — matcher.

   Shopify predictive search matches page titles only. Measured on this store:
   faq finds the FAQs page, while return policy, delivery and cod handling fee
   find nothing, even though all three sit in the FAQ page body. So the answer
   cannot come from the platform; this scores the typed query against the
   bundled questions instead.

   Scoring: 6 per hit in the question, 5 per hit in the keyword list, 1 in the
   teaser, +16 for a verbatim phrase, +14 when the whole query appears inside the
   question. Three gates keep product searches clean — see below.

   Load order: data-a, data-b, tables, match, ui.
   No backslashes and no literal double quotes in the code by design — these
   files are uploaded through a GraphQL block string.

   ---------------------------------------------------------------------------
   THE INTENT GATE, REBUILT 2026-08-05

   It used to be one line: any INTENT word anywhere in the synonym-expanded
   query opened the panel. Measured against all 1,170 product titles, that let
   the panel through on 16.9% of full titles and 4.3% of four-word openings, and
   on four of the five brand collections — college fits, fit, your fit and late
   night thoughts all scored as help questions.

   Two separate faults, fixed here rather than in the word list:

   1. STOP WORDS COULD OPEN THE GATE ON THEIR OWN.
      is, your, my, who, will, can, are, me, where and why sit in both STOP and
      INTENT. STOP already says they carry almost no meaning — they score at a
      quarter weight — yet any one of them alone was enough to decide a query
      was a question. Between them they accounted for 149 of the false opens.
      A real help query always carries a topic word too: is cod available has
      cod, where is my order has order. So the gate now needs an intent word
      that is NOT a stop word.

   2. THE GATE RAN ON THE SYNONYM-EXPANDED WORDS.
      A synonym could smuggle an intent word in that the shopper never typed:
      acid washed expanded washed -> wash and opened the panel on a collection
      name. The gate now reads the RAW typed words. Hinglish still works because
      every synonym key that used to reach INTENT through its expansion, and
      that never appears in a product title, was promoted into INTENT directly
      — wapis, trak, refnd, saiz, paytm and 34 others. Verified: wapis kaise
      kare, paisa kab milega, trak my order and kitne din me delivery hoga all
      still answer correctly.

   Result, same measurement: 0.9% of full titles, 0.5% of four-word openings,
   and none of the five brand collections. 62 of 62 hand-written help queries
   still answer, up from 60 — wrong item and wrong product used to be gated out
   entirely because wrong was not an intent word.

   If you widen INTENT, score it against the catalogue first. A word that
   appears in product titles will open this panel on product searches. */
(function () {
  var S = window.SS_HELP;
  if (!S || !S.DATA) return;
  var DATA = S.DATA, SYN = S.SYN, PHRASE = S.PHRASE, STOP = S.STOP, INTENT = S.INTENT;
  var MIN_SCORE = 5;   /* one keyword hit is the floor */
  var MAX_ROWS = 4;    /* 1 open answer + up to 3 collapsed questions */

  /* ---------------- text helpers (no regex, see the note above) ---------- */
  var KEEP = 'abcdefghijklmnopqrstuvwxyz0123456789 ';

  /* A literal double quote breaks the block-string upload these files ship
     through, so build it from its char code. */
  var DQ = String.fromCharCode(34);

  function fold(s) {
    s = String(s == null ? '' : s).toLowerCase();
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i);
      out += (KEEP.indexOf(ch) > -1) ? ch : ' ';
    }
    return out;
  }

  function words(s) {
    var raw = fold(s).split(' ');
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var w = raw[i];
      if (!w || w.length < 2) continue;
      out.push(w);
    }
    return out;
  }

  function expand(list) {
    var seen = {};
    var out = [];
    function push(w) { if (w && !seen[w]) { seen[w] = 1; out.push(w); } }
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      push(w);
      if (SYN[w]) {
        var extra = SYN[w].split(' ');
        for (var j = 0; j < extra.length; j++) push(extra[j]);
      }
    }
    return out;
  }

  function decode(s) {
    return String(s).split('&quot;').join(DQ);
  }

  /* Pre-fold the searchable text once. */
  for (var d = 0; d < DATA.length; d++) {
    DATA[d].fq = fold(DATA[d].q);
    DATA[d].fk = fold(DATA[d].k);
    DATA[d].fa = fold(decode(DATA[d].t));
  }

  function score(item, qWords, folded) {
    var s = 0;
    for (var i = 0; i < qWords.length; i++) {
      var w = qWords[i];
      var weight = STOP[w] ? 0.25 : 1;
      if (item.fq.indexOf(w) > -1) s += 6 * weight;
      if (item.fk.indexOf(w) > -1) s += 5 * weight;
      if (item.fa.indexOf(w) > -1) s += 1 * weight;
    }
    /* Verbatim hits are decisive — they separate answers whose wording overlaps. */
    if (item.fq.length && folded.length > 5 && item.fq.indexOf(folded) > -1) s += 14;
    var ph = PHRASE[item.i];
    if (ph) {
      var parts = ph.split('|');
      for (var p = 0; p < parts.length; p++) {
        var frag = parts[p].trim();
        if (frag.length > 3 && folded.indexOf(frag) > -1) { s += 16; break; }
      }
    }
    return s;
  }

  /* Called with the RAW typed words, never the expanded ones, and satisfied
     only by an intent word that is not also a stop word. Both conditions are
     load-bearing — see the header. */
  function hasIntent(qWords) {
    for (var i = 0; i < qWords.length; i++) {
      if (INTENT[qWords[i]] && !STOP[qWords[i]]) return true;
    }
    return false;
  }

  function search(query) {
    var folded = fold(query).split(' ').filter(Boolean).join(' ');
    var raw = words(query);
    var w = expand(raw);
    if (!w.length) return [];
    /* Needs one real word, not just stop words. Stops a half-typed when-wi from
       confidently answering the wrong question. */
    var solid = false;
    for (var q = 0; q < w.length; q++) {
      if (!STOP[w[q]] && w[q].length > 2) { solid = true; break; }
    }
    if (!solid) return [];
    /* No question signal, no panel. Product searches stay product searches. */
    if (!hasIntent(raw)) return [];
    var hits = [];
    for (var i = 0; i < DATA.length; i++) {
      var sc = score(DATA[i], w, folded);
      if (sc >= MIN_SCORE) hits.push({item: DATA[i], s: sc});
    }
    hits.sort(function (a, b) { return b.s - a.s; });
    return hits.slice(0, MAX_ROWS);
  }

  S.search = search;
  S.decode = decode;
  S.DQ = DQ;
})();
